import {Stack, Tab, Typography} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import CollectionsTab from "../../../components/admin/user/CollectionsTab";
import GeneralTab from "../../../components/admin/user/GeneralTab";
import {API_URL} from "../../../constants";
import {makeRequest} from "../../../services/requestService";
import LabelsTab from "../../../components/admin/user/LabelsTab";

const tabs = {
    "general": GeneralTab,
    "collections": CollectionsTab,
    "label_set": LabelsTab,
//    "corrections": (props) => <>Corrections</>,
};

async function fetchUser(id) {
    const url = `${API_URL}/user/${id}`;
    const response = await makeRequest(url);

    if (response.status !== 200) {
        throw response;
    }

    return response.data;
}

export default function User(props) {
    const {id} = useParams();
    const {t} = useTranslation('common');
    const [user, setUser] = React.useState({});
    const location = useLocation();
    const history = useHistory();

    React.useEffect(async () => {
        const user = await fetchUser(id);
        setUser(user);
    }, [id]);

    function setTab(tab) {
        history.push("#" + tab);
    }

    const tab = React.useMemo(() => {
        const keys = Object.keys(tabs);
        const tab = location.hash.substring(1);
        return keys.includes(tab) ? tab : keys[0];
    }, [location.hash]);

    function handleUserUpdate(user) {
       setUser(user);
    }

    return (<TabContext value={tab}>
        <Stack>
            <Typography variant="h6" ml={1} fontSize={22} fontWeight="bold" color="textSecondary">
                {user?.name}
            </Typography>
            <TabList onChange={(_, value) => setTab(value)} sx={{borderBottom: '1px solid #e8e8e8'}}>
                {Object.keys(tabs).map((key) => (
                    <Tab key={key} value={key} label={t(`main.pages.admin.user.tabs.${key}.title`)}/>))}
            </TabList>
            {Object.entries(tabs).map(([key, TabComponent]) => (
                <TabPanel key={key} value={key} sx={{m: 0}}>
                    {user.name && <TabComponent user={user} onUserUpdate={handleUserUpdate}/>}
                </TabPanel>
            ))}
        </Stack>
    </TabContext>);
}
